/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectChangeOrderDetailsCommand } from '../../models/create-project-change-order-details-command';
import { CreateProjectChangeOrderDetailsCommandResult } from '../../models/create-project-change-order-details-command-result';

export interface ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Params {
      body?: CreateProjectChangeOrderDetailsCommand
}

export function apiProjectChangeOrderCreateProjectChangeOrderDetailsPost(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderCreateProjectChangeOrderDetailsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateProjectChangeOrderDetailsCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderCreateProjectChangeOrderDetailsPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateProjectChangeOrderDetailsCommandResult>;
    })
  );
}

apiProjectChangeOrderCreateProjectChangeOrderDetailsPost.PATH = '/api/ProjectChangeOrder/CreateProjectChangeOrderDetails';
